import { useState } from 'react';

import Dialog from '../../../shared/designSystem/components/Dialog';
import { useDetermineMobile } from '@myrealtrip/device-detect';

import styled from '@emotion/styled';
import { resetButton } from '../../../styles/reset';

export default function ISMS() {
  const [isOpen, setIsOpen] = useState(false);

  const isMobile = useDetermineMobile();

  const DialogComponent = isMobile ? Dialog.Mobile : Dialog.Desktop;

  const handleToggleDialog = (isDialogOpen: boolean) => setIsOpen(isDialogOpen);

  const Container = isMobile ? MobileContainer : DesktopContainer;

  return (
    <Container>
      <ISMSButton type="button" onClick={() => handleToggleDialog(true)}>
        <ISMSIcon
          src={'https://dffoxz5he03rp.cloudfront.net/etc/img-logo-isms@2x.png'}
          alt="ISMS-P"
        />
      </ISMSButton>
      <DialogComponent isOpen={isOpen} toggle={handleToggleDialog} titleText={' '}>
        {isOpen && (
          <ISMSImage
            src="https://dffoxz5he03rp.cloudfront.net/image-isms.png"
            alt="ISMS-P 인증서"
          />
        )}
      </DialogComponent>
    </Container>
  );
}

const CommonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: auto;
  margin-left: auto;
`;

const MobileContainer = styled(CommonContainer)`
  position: absolute;
  right: 16px;
  bottom: 86px;
`;

const DesktopContainer = CommonContainer;

const ISMSButton = styled.button`
  ${resetButton};
  line-height: 0;
`;

const ISMSIcon = styled.img`
  width: 56px;
`;

const ISMSImage = styled.img`
  width: 100%;
`;
